import { entity } from "simpler-state"

// Store the deduction ID to highlight (persists after modal close)
export const DeductionDetailModalId = entity<string | null>(null)

// Whether the modal is currently open
export const DeductionDetailModalOpen = entity<boolean>(false)

export function openDeductionDetailModal(deductionId: string) {
  DeductionDetailModalId.set(deductionId)
  DeductionDetailModalOpen.set(true)
}

export function closeDeductionDetailModal() {
  DeductionDetailModalOpen.set(false)
  // Don't clear DeductionDetailModalId - keep it for row highlighting
}

// Helper to close modal before navigating (used by links inside modal content)
export function closeModalAndNavigate(navigate: (url: string) => void, url: string) {
  closeDeductionDetailModal()
  navigate(url)
}
